import { Brain, Users, Activity, MessageSquare, Heart } from "lucide-react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

export const TabsNavigation = () => {
  return (
    <div className="flex justify-center w-full overflow-x-auto scrollbar-hide pb-2 md:pb-0">
      <TabsList className="inline-flex h-12 sm:h-14 items-center justify-center rounded-xl bg-gray-100/40 p-1 sm:p-1.5 text-muted-foreground backdrop-blur-sm border border-gray-200/50 shadow-sm gap-1 sm:gap-2 md:gap-3 touch-pan-x">
        <TabsTrigger 
          value="dashboard" 
          className="inline-flex items-center justify-center gap-1 sm:gap-2 rounded-lg px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm hover:bg-white/50 min-h-[40px] sm:min-h-[44px] touch-manipulation"
        >
          <Brain className="w-4 h-4 md:w-5 md:h-5" />
          <span className="hidden sm:inline">Dashboard</span>
        </TabsTrigger>
        
        <TabsTrigger 
          value="care" 
          className="inline-flex items-center justify-center gap-1 sm:gap-2 rounded-lg px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm hover:bg-white/50 min-h-[40px] sm:min-h-[44px] touch-manipulation"
        >
          <Users className="w-4 h-4 md:w-5 md:h-5" />
          <span className="hidden sm:inline">Care</span>
        </TabsTrigger>

        <TabsTrigger 
          value="activity" 
          className="inline-flex items-center justify-center gap-1 sm:gap-2 rounded-lg px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm hover:bg-white/50 min-h-[40px] sm:min-h-[44px] touch-manipulation"
        >
          <Activity className="w-4 h-4 md:w-5 md:h-5" />
          <span className="hidden sm:inline">Activity</span>
        </TabsTrigger>

        <TabsTrigger 
          value="communication" 
          className="inline-flex items-center justify-center gap-1 sm:gap-2 rounded-lg px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm hover:bg-white/50 min-h-[40px] sm:min-h-[44px] touch-manipulation"
        >
          <MessageSquare className="w-4 h-4 md:w-5 md:h-5" />
          <span className="hidden sm:inline">Communication</span>
        </TabsTrigger>

        <TabsTrigger 
          value="support" 
          className="inline-flex items-center justify-center gap-1 sm:gap-2 rounded-lg px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 text-sm md:text-base font-medium transition-all data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:shadow-sm hover:bg-white/50 min-h-[40px] sm:min-h-[44px] touch-manipulation"
        >
          <Heart className="w-4 h-4 md:w-5 md:h-5" />
          <span className="hidden sm:inline">Support</span>
        </TabsTrigger>
      </TabsList>
    </div>
  );
};